import dayjs from "dayjs";
import { PERIODS } from "../../enums/StatsTimes.enum";
import Duration from 'dayjs/plugin/duration'

dayjs.extend(Duration)


export const getDatesFromSelectedPeriod = (days: number) => {
    return {
        "date[before]": dayjs().toISOString(),
        "date[after]": dayjs().subtract(days, 'days').toISOString(),
    }
}